import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { Link as LinkRouter } from 'react-router-dom';
import { Link } from '@mui/material';
import { CustomButton } from '../../../../../components';
import { capitalize, formatPhoneNumber } from '../../../../../utils';
import { sendInvoice } from '../../../../../core/balance/action';
import {
  APPLICATION_STATUS,
  PAYMENT_STATUS,
} from '../../../../../constants/event-application-status';
import { APP_ROUTES } from '../../../../../constants/app-routes';

export default function Row({ row, openDetails }) {
  const { event, vendor } = row;
  const dispatch = useDispatch();

  const onSendInvoiceClicked = (eventId, vendorId) => {
    dispatch(sendInvoice(eventId, vendorId));
  };

  const formatStatus = (status) => {
    if (status === PAYMENT_STATUS.BALANCE_DUE) {
      return 'Balance Due';
    }

    return capitalize(status);
  };

  return (
    <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
      <TableCell align="left">
        <LinkRouter to={APP_ROUTES.VENDOR_PUBLIC_PROFILE.replace(':vendorId', vendor.id)}>
          {vendor?.name} {vendor?.last_name}
        </LinkRouter>
      </TableCell>
      <TableCell align="left">{vendor?.vendor_company_name}</TableCell>
      <TableCell align="left">
        {
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <Link
            color="#0000EE"
            component="button"
            variant="body2"
            onClick={() => {
              openDetails(row);
            }}>
            View
          </Link>
        }
      </TableCell>
      <TableCell align="left">{`USD $${row?.total_price}`}</TableCell>
      <TableCell align="left">{vendor?.email}</TableCell>
      <TableCell align="left">{formatPhoneNumber(vendor.phone_number)}</TableCell>
      <TableCell align="left">
        {row.application_status === APPLICATION_STATUS.APPROVED && formatStatus(row?.status ?? '')}
      </TableCell>
      <TableCell align="left">{capitalize(row.application_status ?? '')}</TableCell>
      <TableCell align="left">
        {row.application_status === APPLICATION_STATUS.APPROVED &&
          row.status !== PAYMENT_STATUS.PAID && (
            <CustomButton
              style={{ width: '100px' }}
              padding="5px"
              variant="outlined"
              onClick={() => onSendInvoiceClicked(event.id, vendor.id)}>
              Send Invoice
            </CustomButton>
          )}
      </TableCell>
    </TableRow>
  );
}

Row.propTypes = {
  row: PropTypes.instanceOf(Object).isRequired,
  openDetails: PropTypes.func.isRequired,
};
